<template>
  <div>
    <div
      class="text-nowrap py-1"
      v-show="data.order_branch_name"
    >
      <span class="text--secondary">Order branch:</span>
      {{ data.order_branch_name }}
    </div>
    <div
      class="text-nowrap pb-1"
      v-show="data.approve_branch_name"
    >
      <span class="text--secondary">Approve branch:</span>
      {{ data.approve_branch_name }}
    </div>
    <div
      class="text-nowrap pb-1"
      v-show="data.deliver_branch_name"
    >
      <span class="text--secondary">Deliver branch:</span>
      {{ data.deliver_branch_name }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: { type: Object, required: true }
  }
}
</script>



// WEBPACK FOOTER //
// src/DisplayBranch.vue